import { ICheckDigitPro } from "../models/osd";
export const EXPORT_LIMIT = 5000;
export enum ETab {
  dashboard = 0,
  myAssignments = 1,
  overages = 2,
  shortages = 3,
  damages = 4,
  onHandDelivery = 5,
  misdelivery = 6,
  cleared = 7,
  maintenance = 9,
  unauthorized = 10,
}

export enum DType {
  pro = "pro",
  od400 = "od400",
  assignTo = "assignTo",
  assignBy = "assignBy",
  entryBy = "entryBy",
  osd = "osd",
  zip = "zip",
  city = "city",
  commodity = "commodity",
  terminal = "terminal",
}

export const MAX_LENGTH_MANIFEST_NUMBER = 9;
export const MAX_LENGTH_PRO = 11;
export const MAX_LENGTH_PHONE_NUMBER = 12;
export const MAX_LENGTH_MEDIUM_ENTRY = 30;
export const MAX_LENGTH_SUMMARY_TEXT = 150;

export const MAX_FILE_SIZE = 200 * 1024; // 200KB in bytes
export const MIN_FILE_SIZE = 1 * 1024; // 1KB in bytes
export const MAX_PDF_SIZE = 4 * 1024 * 1024; // 4MB in bytes
// type of page object for data grid pagination

export type TPageObject = {
  page: number;
  pageSize: number;
};

export type TMasterSearchParameter = {
  search: string;
  page: number;
  limit: number;
  includeInactiveUsers?: boolean;
};

export type TGridSortModel = {
  field?: string;
  sort: "asc" | "desc" | null | undefined | "ASC" | "DESC";
};

export enum EUploadKey {
  od400Pro = "od400ProNumber",
  pro = "proNumber",
}

const commonGridHeadings = {
  assignedToName: "Assigned to",
  investigationStatus: "Investigation Status",
  osdNumber: "Exception #",
  osdType: "Exception code",
  entryDate: "Entry date",
  entryBy: "Entry User",
  proNumber: "Pro #",
  pickupDate: "Pickup Date",
  shipperName: "Shipper Name",
  consigneeName: "Consignee Name",
  origin: "Origin terminal",
  destination: "Destination terminal",
  reporting: "Reporting terminal",
  commodity: "Commodity",
  description: "Description",
  viewDescription: "View",
  valueRange: "Value Range",
  value1k: "Value",
  lastManifest: "Last confirmed manifest #",
};

const commonSortingDisabledColumns = [
  "photos",
  "clearSwitch",
  "viewDescription",
  "commodity",
  "description",
  "consigneeDetails",
  "cleared"
];

export const APP: any = {
  showTerminalPickerPage: [
    ETab.dashboard,
    ETab.overages,
    ETab.shortages,
    ETab.damages,
    ETab.onHandDelivery,
    ETab.misdelivery,
    ETab.cleared,
  ],
  showHeaderSearchPage: [
    ETab.myAssignments,
    ETab.overages,
    ETab.shortages,
    ETab.damages,
    ETab.onHandDelivery,
    ETab.misdelivery,
    ETab.cleared,
  ],
  overageRowSelectable: { key: "investigationStatus", value: "complete" },
  sortModel: { field: "entryDate", sort: "desc" },
  pageObject: { pageSize: 25, page: 0 },
  rowsPerPageOptions: [25, 50, 100],
  dataTablePhotoViewTypes: ["EL", "EP", "UD", "1B", "BP", "EX", "FX", "HP", "MP", "TK", "UP", "WP", "OD"],
  sendAPBImageType: ["OD", "BP", "WP", "EL", "WX", "EP", "DR", "FX", "BL"],
  sendDispositionImageType: ["EP", "BL", "DR", "BP", "FX"],
  myAssignments: {
    gridHeading: {
      assignedByName: "Assigned by",
      investigationStatus: "Investigation Status",
      osdNumber: "Exception #",
      osdType: "Exception code",
      entryDate: "Entry date",
      entryBy: "Entry User",
      proNumber: "Pro #",
      pickupDate: "Pickup Date",
      od400ProNumber: "OD400 Pro #",
      shipperName: "Shipper Name",
      consigneeName: "Consignee Name",
      consigneeDetails: "MSD Full Address",
      origin: "Origin terminal",
      destination: "Destination/Pickup terminal",
      reporting: "Reporting terminal",
      commodity: "Commodity",
      description: "Description",
      viewDescription: "View",
      valueRange: "Value Range",
      value1k: "Value",
      lastManifest: "Last Manifest #",
      pickupNumber: "Pickup #",
      trailer: "Trailer #",
      exceptionLocation: "Current Location",
      misdeliveredBolPro: "New PRO #",
      misdeliveredPalletPro: "PRO Applied To",
      driverName: "Driver's Name",
      dockWorkerName: "Dock Worker's Name",
      photos: "Photos",
      clearSwitch: "Clear",
    },
  },
  dashboard: {
    gridHeading: {
      cleared: "Cleared",
      assignedToName: "Assigned to",
      investigationStatus: "Investigation Status",
      osdNumber: "Exception #",
      osdType: "Exception code",
      entryDate: "Entry date",
      entryBy: "Entry User",
      proNumber: "Pro #",
      pickupDate: "Pickup Date",
      od400ProNumber: "OD400 Pro #",
      shipperName: "Shipper Name",
      consigneeName: "Consignee Name",
      consigneeDetails: "MSD Full Address",
      origin: "Origin terminal",
      destination: "Destination/Pickup terminal",
      reporting: "Reporting terminal",
      commodity: "Commodity",
      description: "Description",
      viewDescription: "View",
      valueRange: "Value Range",
      value1k: "Value",
      lastManifest: "Last Manifest #",
      pickupNumber: "Pickup #",
      trailer: "Trailer #",
      exceptionLocation: "Current Location",
      misdeliveredBolPro: "New PRO #",
      misdeliveredPalletPro: "PRO Applied To",
      driverName: "Driver's Name",
      dockWorkerName: "Dock Worker's Name",
      photos: "Photos",
      clearSwitch: "Clear",
    },
  },
  overage: {
    id: "osdNumber",
    userAPILimit: 10,
    userAPIpageLimit: 1,
    gridHeading: {
      assignedToName: "Assigned to",
      investigationStatus: "Investigation Status",
      osdNumber: "Exception #",
      osdType: "Exception code",
      entryDate: "Entry date",
      entryBy: "Entry User",
      proNumber: "Pro #",
      pickupDate: "Pickup Date",
      od400ProNumber: "OD400 Pro #",
      shipperName: "Shipper Name",
      consigneeName: "Consignee Name",
      origin: "Origin terminal",
      destination: "Destination terminal",
      reporting: "Reporting terminal",
      commodity: "Commodity",
      description: "Description",
      viewDescription: "View",
      valueRange: "Value Range",
      value1k: "Value",
      lastManifest: "Last Manifest #",
      trailer: "Trailer #",
      exceptionLocation: "Current Location",
      photos: "Photos",
      clearSwitch: "Clear",
    },
    sortingDisabledColumns: commonSortingDisabledColumns,
    overageDetailsColumns: [
      {
        headerName: "Exception #",
        field: "osdNumber",
        sortable: false,
        flex: 1,
      },
      { headerName: "Type", field: "osdType", sortable: false, flex: 1 },
      { headerName: "Origin", field: "origin", sortable: false, flex: 1 },
      { headerName: "Dest", field: "destination", sortable: false, flex: 1 },
      { headerName: "Rept", field: "reporting", sortable: false, flex: 1 },
      { headerName: "Reg", field: "regionTerminal", sortable: false, flex: 1 },
      { headerName: "PRO #", field: "proNumber", sortable: false, flex: 1 },
      { headerName: "Trailer", field: "trailer", sortable: false, flex: 1 },
      { headerName: "Manifest", field: "manifest", sortable: false, flex: 1 },
      {
        headerName: "Entry Date",
        field: "entryDate",
        sortable: false,
        flex: 1,
      },
      {
        headerName: "Entry Time",
        field: "entryTime",
        sortable: false,
        flex: 1,
      },
      { headerName: "Entry By", field: "entryBy", sortable: false, flex: 1 },
      {
        headerName: "Sum of Total Value",
        field: "value1k",
        sortable: false,
        flex: 1,
      },
      { headerName: "Haz Mat", field: "hazmat", sortable: false, flex: 1 },
    ],

    overagesShipperDetails: [
      { headerName: "Shipper", field: "shipperName", sortable: false, flex: 1 },
      {
        headerName: "Address",
        field: "shipperAddress",
        sortable: false,
        flex: 1,
      },
      { headerName: "city", field: "shipperCity", sortable: false, flex: 1 },
      { headerName: "State", field: "shipperState", sortable: false, flex: 1 },
      { headerName: "Zip", field: "shipperZip", sortable: false, flex: 1 },
    ],

    overageConsigneeDetails: [
      {
        headerName: "Consignee",
        field: "consigneeName",
        sortable: false,
        flex: 1,
      },
      {
        headerName: "Address",
        field: "consigneeAddress",
        sortable: false,
        flex: 1,
      },
      { headerName: "city", field: "consigneeCity", sortable: false, flex: 1 },
      {
        headerName: "State",
        field: "consigneeState",
        sortable: false,
        flex: 1,
      },
      { headerName: "Zip", field: "consigneeZip", sortable: false, flex: 1 },
    ],
    manifestProColumns: [
      {
        field: "proNumber",
        headerName: "Pro Number",
        sortable: false,
        flex: 1,
      },
      // { field: "exln", headerName: "EXLN", sortable: false, flex: 1 },
      {
        field: "hazmat",
        headerName: "Haz Mat",
        sortable: false,
        minWidth: 20,
        flex: 1,
      },
      { field: "shipper", headerName: "Shipper", sortable: false, flex: 1 },
      { field: "consignee", headerName: "Consignee", sortable: false, flex: 1 },
      // { field: "payer", headerName: "Payer (P/C/3)", sortable: false, flex: 1 },
      { field: "destination", headerName: "DEST", sortable: false, flex: 1 },
      { field: "handlingUnits", headerName: "H/U", sortable: false, flex: 1 },
      { field: "totalPieces", headerName: "Pieces", sortable: false, flex: 1 },
      { field: "weight", headerName: "WGT", sortable: false, flex: 1 },
      { field: "cubicFeet", headerName: "CUFT", sortable: false, flex: 1 },
    ],
  },
  shortage: {
    gridHeading: {
      ...commonGridHeadings,
      manifest: "Manifest Short Reported On", // Unique to shortage
      trailer: "Trailer #",
      photos: "Photos",
      clearSwitch: "Clear",
    },
    sortingDisabledColumns: commonSortingDisabledColumns,
  },
  damage: {
    gridHeading: {
      ...commonGridHeadings,
      trailer: "Trailer #",
      photos: "Photos",
      clearSwitch: "Clear",
    },
    sortingDisabledColumns: commonSortingDisabledColumns,
  },
  onHandDelivery: {
    gridHeading: {
      assignedToName: "Assigned to",
      investigationStatus: "Investigation Status",
      osdNumber: "Exception #",
      osdType: "Exception code",
      entryDate: "Entry date",
      entryBy: "Entry User",
      proNumber: "Pro #",
      pickupDate: "Pickup Date",
      shipperName: "Shipper Name",
      consigneeName: "Consignee Name",
      origin: "Origin terminal",
      destination: "Destination terminal",
      reporting: "Reporting terminal",
      commodity: "Commodity",
      description: "Description",
      viewDescription: "View",
      valueRange: "Value Range",
      value1k: "Value",
      trailer: "Trailer #",
      lastManifest: "Last confirmed manifest #",
      photos: "Photos",
      clearSwitch: "Clear",
    },
    sortingDisabledColumns: commonSortingDisabledColumns,
  },
  misdelivery: {
    gridHeading: {
      assignedToName: "Assigned to",
      investigationStatus: "Investigation Status",
      osdType: "Exception code",
      osdNumber: "Exception #",
      entryDate: "Entry date",
      entryBy: "Entry User",
      proNumber: "MSD Pro #",
      pickupDate: "Pickup Date",
      consigneeDetails: "MSD Full Address",
      origin: "Origin terminal",
      destination: "Pickup terminal",
      reporting: "Reporting terminal",
      description: "Description",
      lastManifest: "Last confirmed manifest #",
      pickupNumber: "Pickup #",
      misdeliveredBolPro: "New PRO #",
      misdeliveredPalletPro: "PRO Applied To",
      od400ProNumber: "OD400 #",
      driverName: "Driver's Name",
      dockWorkerName: "Dock Worker's Name",
      photos: "Photos",
      clearSwitch: "Clear",
    },
    sortingDisabledColumns: commonSortingDisabledColumns,
  },
  cleared: {
    gridHeading: {
      clearingCode: "Clearing Code",
      osdNumber: "Exception #",
      osdType: "Exception code",
      entryDate: "Entry date",
      entryBy: "Entry User",
      proNumber: "Pro #",
      pickupDate: "Pickup Date",
      od400ProNumber: "OD400 Pro #",
      shipperName: "Shipper Name",
      consigneeName: "Consignee Name",
      origin: "Origin terminal",
      destination: "Destination/Pickup terminal",
      reporting: "Reporting terminal",
      commodity: "Commodity",
      description: "Description",
      valueRange: "Value Range",
      value1k: "Value",
      lastManifest: "Last confirmed manifest #",
      exceptionLocation: "Current Location",
      misdeliveredBolPro: "New PRO #",
      misdeliveredPalletPro: "PRO Applied To",
      trailer: "Trailer #",
      pickupNumber: "Pickup #",
      photos: "Photos",
    },
    sortingDisabledColumns: commonSortingDisabledColumns,
  },
  OverageEntryFields: [
    "proNumber",
    "reporting",
    "origin",
    "destination",
    "shipperAccount",
    "consigneeAccount",
    "type",
    "shipper",
    "shipperAddress",
    "shipperCity",
    "shipperState",
    "shipperZip",
    "consigneeCity",
    "consigneeState",
    "consigneeZip",
    "consignee",
    "consigneeAddress",
    "od400Completed",
    "poNumber",
    "od400Manifest",
    "shrinkWrap",
    "itemCartonModelSerialNumber",
    "weight",
    "manufacturerBrand",
    "billNumber",
    "snNumber",
    "hazmat",
    "trailer",
    "bay",
    "exceptionLocation",
    "commodity",
    "package",
    "pieces",
    "od400ProNumber",
    "handlingUnits",
    "valueRange",
    "dimension",
    "barcode",
    "additionalDescription",
    "heatNumbers",
    "colorCode",
    "agentInterline",
    "trailerOrBay",
    "value1k",
  ],
  NBInvestigationFields: [
    "osdType",
    "od400Check",
    "od400CheckResponse",
    "markingsCheck",
    "markingsCheckResponse",
    "thCheck",
    "thCheckResponse",
    "mfCheck",
    "mfCheckResponse",
    "osAndDCheck",
    "osAndDCheckResponse",
    "googleCheck",
    "googleCheckResponse",
    "unmanifestedCheck",
    "unmanifestedCheckResponse",
    "undeliveredCheck",
    "undeliveredCheckResponse",
    "customerDeliveryCheck",
    "customerDeliveryCheckResponse",
    "undelInvCheck",
    "undelInvCheckResponse",
    "apbCheck",
    "apbCheckResponse",
    "emailCheck",
    "emailCheckResponse",
  ],
  OVInvestigationFields: [
    "osdType",
    "od400Check",
    "od400CheckResponse",
    "billOfLadingCheck",
    "billOfLadingCheckResponse",
    "drCheck",
    "drCheckResponse",
    "psCheck",
    "psCheckResponse",
    "consigneeCheck",
    "consigneeCheckResponse",
    "shipmentCheck",
    "shipmentCheckResponse",
  ],

  documentColumns: {
    name: "File Name",
    docType: "Doc Type",
    id: "Delete",
  },
};

export const CHECK_DIGIT_FIELDS: Array<keyof ICheckDigitPro> = [
  "origin",
  "destination",
  "consignee",
  "consigneeZip",
  "shipper",
  "shipperCity",
  "shipperState",
  "shipperZip",
  "consigneeAccount",
  "consigneeAddress",
  "consigneeCity",
  "consigneeState",
  "shipperAccount",
  "shipperAddress",
  "ilScac",
  "thirdPartyName",
  "thirdPartyAddress1",
  "thirdPartyAddress2",
  "thirdPartyCity",
  "thirdPartyState",
  "thirdPartyZip",
];

export enum EFormAction {
  edit = "edit",
  create = "create",
  typeChanged = "typeChanged",
  submit = "submit",
  freightLocated = "freightLocated",
  save = "save",
  complete = "complete",
  update = "update",
  followupSave = "followupSave",
  credit = "credit"
}

export enum HeaderActionType {
  create = "submit",
  uopdate = "save",
  followupSave = "save",
  submit = "submit",
  complete = "submit",
  edit = "save",
  freightLocated = "freightLocated",
}

export enum EAutoSearchFieldName {
  name = "Name",
  od400 = "OD400 PRO #",
  pro = "PRO #",
  osdNumber = "Exception #",
  username = "Username",
  zip = "Zip",
  city = "City",
}

export enum EDataGridEvent {
  onSort = "onSort",
  pageChange = "pageChange",
  assigned = "assigned",
}

export enum AppURLs {
  dashboard = "/dashboard",
  overages = "/overages",
  overageEntry = "/overage/entry",
  editOverageEntry = "/overage/entry/:osdNumber",
  viewDescription = "/exception/:osdNumber",
  manifestDetails = "/manifest/:id",
  myAssignments = "/myAssignments",
  searchException = "/exceptions/search",
  shortages = "/shortages",
  damages = "/damages-refusals",
  onHandDelivery = "/on-hand-delivery",
  misdelivery = "/misdelivery",
  sendAPB = "/exception/:osdNumber/apb/send",
  shortageEntry = "/all-shortages/entry",
  editASEntry = "/all-shortages/entry/:osdNumber",
  editDSEntry = "/delivered-short/entry/:osdNumber",
  editBNF = "/bnf/entry/:osdNumber",
  editPR = "/pr/entry/:osdNumber",
  editRD = "/rd/entry/:osdNumber",
  editRF = "/rf/entry/:osdNumber",
  editDD = "/dd/entry/:osdNumber",
  editOH = "/on-hand-delivery/entry/:osdNumber",
  ohEntry = "/on-hand-delivery/entry",
  editMD = "/misdelivery/entry/:osdNumber",
  mdEntry = "/misdelivery/entry",
  sendDisposition = "/exception/:osdNumber/send-disposition",
  cleared = "/clearedExceptions",
}

export const enum EOsdType {
  ov = "OV",
  nb = "NB",
  as = "AS",
  ds = "DS",
  bnf = "BNF",
  pr = "PR",
  rd = "RD",
  rf = "RF",
  dd = "DD",
  oh = "OH",
  msd = "MSD",
}

// Grouped subsets using the enum values
export const DAMAGE_OSD_TYPE: EOsdType[] = [
  EOsdType.pr,
  EOsdType.rd,
  EOsdType.rf,
  EOsdType.dd,
];

export const OVERAGE_OSD_TYPES: EOsdType[] = [EOsdType.ov, EOsdType.nb];

export const SHORTAGE_OSD_TYPES: EOsdType[] = [
  EOsdType.as,
  EOsdType.ds,
  EOsdType.bnf,
];

export const ON_HAND_DELIVERY_OSD_TYPES: EOsdType[] = [EOsdType.oh];

export const MISDELIVERY_OSD_TYPES: EOsdType[] = [EOsdType.msd];

export const ALL_OSD_TYPES: EOsdType[] = [
  ...OVERAGE_OSD_TYPES,
  ...SHORTAGE_OSD_TYPES,
  ...DAMAGE_OSD_TYPE,
  ...ON_HAND_DELIVERY_OSD_TYPES,
  ...MISDELIVERY_OSD_TYPES,
];

export const OSD_TYPE_TO_TAB_MAPPING: Record<ETab, EOsdType[]> = {
  [ETab.myAssignments]: ALL_OSD_TYPES,
  [ETab.dashboard]: ALL_OSD_TYPES,
  [ETab.overages]: OVERAGE_OSD_TYPES,
  [ETab.shortages]: SHORTAGE_OSD_TYPES,
  [ETab.damages]: DAMAGE_OSD_TYPE,
  [ETab.onHandDelivery]: ON_HAND_DELIVERY_OSD_TYPES,
  [ETab.misdelivery]: MISDELIVERY_OSD_TYPES,
  [ETab.cleared]: ALL_OSD_TYPES,
  [ETab.maintenance]: [],
  [ETab.unauthorized]: [],
};

export const FILTERED_REPORTING_TABS = [
  ETab.shortages,
  ETab.damages,
  ETab.myAssignments,
  ETab.dashboard,
  ETab.misdelivery,
  ETab.cleared,
];

export const FILTERED_DESTINATION_TABS = [
  ETab.overages,
  ETab.myAssignments,
  ETab.dashboard,
  ETab.onHandDelivery,
];

export const TAB_TO_GRID_HEADING_MAP: {
  [key in ETab]?: { [key: string]: string };
} = {
  [ETab.shortages]: APP.shortage.gridHeading,
  [ETab.damages]: APP.damage.gridHeading,
  [ETab.onHandDelivery]: APP.onHandDelivery.gridHeading,
  [ETab.misdelivery]: APP.misdelivery.gridHeading,
  [ETab.overages]: APP.overage.gridHeading,
  [ETab.myAssignments]: APP.myAssignments.gridHeading,
  [ETab.dashboard]: APP.dashboard.gridHeading,
  [ETab.cleared]: APP.cleared.gridHeading,
};

export const DATATABLE_VIEW_EDIT_URLS: { [key: string]: string | undefined } = {
  NB: AppURLs.editOverageEntry,
  OV: AppURLs.editOverageEntry,
  AS: AppURLs.editASEntry,
  DS: AppURLs.editDSEntry,
  BNF: AppURLs.editBNF,
  PR: AppURLs.editPR,
  RD: AppURLs.editRD,
  RF: AppURLs.editRF,
  DD: AppURLs.editDD,
  OH: AppURLs.editOH,
  MSD: AppURLs.editMD,
};

export interface TooltipState {
  [key: string]: boolean;
}

export const INITIAL_EXPANDED_PANELS = ["panel1"];
export const ACCORDION_PANELS = [
  {
    id: "panel1",
    number: "1",
    title: "Misdelivery Entry",
    contentId: "misdeliveryEntry",
  },
  {
    id: "panel2",
    number: "2",
    title: "Misdelivery BOL",
    contentId: "misdeliveryBOL",
  },
  {
    id: "panel3",
    number: "3",
    title: "Misdelivery Investigation",
    contentId: "misdeliveryInvestigation",
  },
  {
    id: "panel4",
    number: "4",
    title: "Upload Documents",
    content: "UploadDocument",
  },
];

const getSearchableFields = (gridHeading: Record<string, any>) =>
  Object.keys(gridHeading).filter(
    (key) => !["photos", "clearSwitch", "viewDescription"].includes(key),
  );

export const SEARCHABLE_FIELDS: Record<ETab, string[]> = {
  [ETab.shortages]: getSearchableFields(APP.shortage.gridHeading),
  [ETab.damages]: getSearchableFields(APP.damage.gridHeading),
  [ETab.onHandDelivery]: getSearchableFields(APP.onHandDelivery.gridHeading),
  [ETab.misdelivery]: getSearchableFields(APP.misdelivery.gridHeading),
  [ETab.overages]: getSearchableFields(APP.overage.gridHeading),
  [ETab.myAssignments]: getSearchableFields(APP.myAssignments.gridHeading),
  [ETab.dashboard]: getSearchableFields(APP.dashboard.gridHeading),
  [ETab.cleared]: getSearchableFields(APP.cleared.gridHeading),
  [ETab.maintenance]: [],
  [ETab.unauthorized]: [],
};
